/* Gift add-ons: expand category cards, quick-add via /cart/add.js,
   and keep "Added" states in sync with the cart. */
(function () {
  /* Expand / collapse cards (delegated — works on product page and in the drawer). */
  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-ga-toggle]');
    if (!t) return;
    var card = t.closest('[data-ga-card]');
    var panel = card && card.querySelector('.ga-panel');
    if (!panel) return;
    var willOpen = panel.hidden;
    var sec = card.closest('[data-gift-addons]');
    if (sec) {
      sec.querySelectorAll('.ga-panel').forEach(function (p) { p.hidden = true; });
      sec.querySelectorAll('[data-ga-toggle]').forEach(function (x) { x.setAttribute('aria-expanded', 'false'); });
      sec.querySelectorAll('[data-ga-card]').forEach(function (c) { c.classList.remove('is-open'); });
    }
    panel.hidden = !willOpen;
    t.setAttribute('aria-expanded', String(willOpen));
    if (willOpen) card.classList.add('is-open');
  });
  document.addEventListener('keydown', function (e) {
    if ((e.key === 'Enter' || e.key === ' ') && e.target.matches && e.target.matches('[data-ga-toggle]')) {
      e.preventDefault();
      e.target.click();
    }
  });

  /* "No thanks" on the Boulevard Box banner — collapse it into the gift strip. */
  document.addEventListener('click', function (e) {
    var d = e.target.closest('[data-ga-decline]');
    if (!d) return;
    var banner = d.closest('[data-ga-box-banner]');
    if (banner) banner.setAttribute('data-declined', '1');
    var sec = d.closest('[data-gift-addons]');
    if (sec) {
      var card = sec.querySelector('[data-ga-box-card]');
      if (card) card.hidden = false;
    }
  });

  /* Quick-add an add-on. Prep properties ride along so gifts never extend the slot window. */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-addon-add]');
    if (!btn || btn.disabled) return;
    btn.disabled = true;
    btn.textContent = 'Adding…';
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({
        id: btn.getAttribute('data-variant-id'),
        quantity: 1,
        properties: {
          '_prep_minutes': btn.getAttribute('data-prep-minutes') || '0',
          '_nextday': btn.getAttribute('data-prep-nextday') || '0',
          '_cutoff_11am': btn.getAttribute('data-prep-cutoff') || '0'
        }
      })
    })
      .then(function (r) {
        if (!r.ok) throw new Error('add failed');
        return r.json();
      })
      .then(function () {
        if (window.FB && window.FB.refreshCart) return window.FB.refreshCart();
      })
      .then(function () {
        if (window.FB && window.FB.openDrawer) window.FB.openDrawer();
        btn.disabled = true;
        btn.textContent = 'Added ✓';
        btn.classList.add('is-added');
        syncStates();
      })
      .catch(function () {
        window.alert('Could not add — please try again.');
        btn.disabled = false;
        btn.textContent = 'Add';
      });
  });

  /* Mark buttons for variants already in the cart as "Added ✓";
     hide cards whose every product is already in the cart;
     hide the cart upsell when the cart is empty. */
  function syncStates() {
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var inCart = {};
        (cart.items || []).forEach(function (it) { inCart[String(it.variant_id)] = true; });
        var cartEmpty = (cart.item_count || 0) === 0;
        document.querySelectorAll('[data-gift-addons]').forEach(function (sec) {
          var secVisible = false;
          sec.querySelectorAll('[data-ga-card]').forEach(function (card) {
            var rows = card.querySelectorAll('[data-addon-add]');
            var allAdded = rows.length > 0;
            rows.forEach(function (b) {
              var added = !!inCart[String(b.getAttribute('data-variant-id'))];
              b.classList.toggle('is-added', added);
              b.disabled = added;
              b.textContent = added ? 'Added ✓' : 'Add';
              if (!added) allAdded = false;
            });
            card.style.display = allAdded ? 'none' : '';
            if (!allAdded) secVisible = true;
          });
          if (sec.getAttribute('data-ga-context') === 'cart') {
            sec.style.display = (!cartEmpty && secVisible) ? '' : 'none';
          }
        });
      })
      .catch(function () { /* upsell stays as rendered */ });
  }

  /* Re-sync whenever the drawer re-renders (main-form adds, qty changes, removals). */
  var drawerBody = document.querySelector('[data-cart-body]');
  if (drawerBody && 'MutationObserver' in window) {
    var t = null;
    new MutationObserver(function () {
      clearTimeout(t);
      t = setTimeout(syncStates, 150);
    }).observe(drawerBody, { childList: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', syncStates);
  } else {
    syncStates();
  }
})();

/* ---------- Free gift bag on $100+ orders ----------
   When the merchandise subtotal (excluding the free bag itself) reaches $100,
   a complimentary gift bag is added automatically. Removed automatically when
   the cart drops below $100. Skipped when THE BOULEVARD BOX is in the cart
   (the bag already comes in the package). If the customer removes the free
   bag themselves, it stays removed until the cart dips below $100 and back. */
(function initFreeBag() {
  var THRESHOLD = 10000; /* $100 in cents */
  var addedThisCycle = false;
  var hooked = false;

  function cfg() {
    var root = document.querySelector('.gift-addons[data-comp-bag-variant]');
    if (!root || !root.dataset.compBagVariant) return null;
    return {
      compId: String(root.dataset.compBagVariant),
      boxId: root.dataset.boxVariant ? String(root.dataset.boxVariant) : null
    };
  }

  function refresh() {
    if (window.FB && window.FB.refreshCart) window.FB.refreshCart();
  }

  function sync(cart) {
    var c = cfg();
    if (!c || !cart) return Promise.resolve();
    var items = cart.items || [];
    function isComp(i) { return String(i.variant_id) === c.compId; }
    function isBox(i) { return c.boxId && String(i.variant_id) === c.boxId; }
    var hasComp = items.some(isComp);
    var hasBox = items.some(isBox);
    var subtotal = items.reduce(function (s, i) {
      return isComp(i) ? s : s + (i.final_line_price || 0);
    }, 0);
    var qualified = subtotal >= THRESHOLD && !hasBox;

    if (!qualified) {
      addedThisCycle = false;
      if (!hasComp) return Promise.resolve();
      var line = items.filter(isComp)[0];
      return fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: line.key, quantity: 0 })
      }).then(refresh);
    }
    if (hasComp || addedThisCycle) return Promise.resolve();
    addedThisCycle = true;
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: c.compId, quantity: 1, properties: { _prep_minutes: 0 } })
    }).then(refresh);
  }

  function fetchCart() {
    return fetch('/cart.js').then(function (r) { return r.json(); });
  }

  function hook() {
    if (hooked || !window.FB || !window.FB.refreshCart) return;
    hooked = true;
    var orig = window.FB.refreshCart;
    window.FB.refreshCart = function () {
      var r = orig.apply(this, arguments);
      Promise.resolve(r).then(fetchCart).then(sync).catch(function () {});
      return r;
    };
    fetchCart().then(sync).catch(function () {}); /* persistent carts */
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', hook);
  } else {
    hook();
  }
  var tries = 0;
  var t = setInterval(function () {
    if (hooked || ++tries > 40) { clearInterval(t); return; }
    hook();
  }, 500);
})();

  /* "No thanks" on the Teddy Bear banner — just hide it. */
  document.addEventListener('click', function (e) {
    var d = e.target.closest('[data-ga-bear-decline]');
    if (!d) return;
    var banner = d.closest('[data-ga-bear-banner]');
    if (banner) banner.setAttribute('data-declined', '1');
  });
